import { DateTime } from 'luxon'

/** Appointment times in the product are the practice clock in Germany. */
export const PRACTICE_TIME_ZONE = 'Europe/Berlin'

export function inPracticeZone(dateTime: DateTime): DateTime {
    return dateTime.setZone(PRACTICE_TIME_ZONE)
}
